import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles(() => ({
  linksContainer: {
    display: "grid",
    gridTemplateAreas: `
    'desktopTitle . mobileTitle'
    'desktopLinks . mobileLinks'
    `,
    gridGap: "1rem",
  },
  desktopTitle: {
    gridArea: "desktopTitle",
  },
  mobileTitle: {
    gridArea: "mobileTitle",
  },
  desktopLinks: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    gridArea: "desktopLinks",
  },
  mobileLinks: {
    display: "flex",
    justifyContent: "space-around",
    gridArea: "mobileLinks",
    alignItems: "center",
  },
  title: {},
}));
